import React, { Fragment } from 'react'
import { Title, Logo, Header, SubTitle, Multiselect, Cards, Footer, Counter, Login } from '../components'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { updateFilter, linkedinLogin, belatedOptin } from '../modules/positions'
import { filteredSlection } from '../modules/selectors'
import store from '../store'

const NotSignedInText = () => <div>
  <p className="card-text linkedin-login">
    Connect to view.
  </p>
</div>

class SubscribeButton extends React.Component {
  
  state = {
    active: true,
  }

  _onClick = () => {
    if (this.state.active) {
      this.setState({ active: false })
      this.props.onClick()
    }
    window.open("https://jobs.aleph.vc/?talents", "_blank")
  }

  render() {
    return (
      <div
      onClick={this._onClick}
      style={{
        backgroundColor: this.state.active ? '#388A95' : '#77BAC2',
        color: 'white',
        display:'inline',
        padding: '5px 10px',
        borderRadius: '5px',
        margin: '0 5px',
        cursor: this.state.active ? 'pointer' : 'default'
      }}>
        Complete Profile
      </div>
    )
  }
  
}

class WelcomeBackText extends React.Component {

  render () {
    const { user, onOptInToggle } = this.props
    const text = (user && user._profile) ? `Welcome back, ${user._profile.name.split(' ')[0]}` : 'Welcome back' 
    return (
      <div>
        <p className="card-text linkedin-login">
          {text}<br/>
          { (
            <small>
              Want to get Personalized opportunities matching your skills and desires? <br/>
              Want to be the first to hear about positions in our unannounced portfolio companies? <br/>
              Complete your profile and we'll start working for you
              <SubscribeButton onClick={onOptInToggle}/>
            </small>
          )}
        </p>
      </div>
    )
  }
}


const Main = ({
  positions,
  locations,
  companies,
  roles,
  skills,
  updateFilter,
  linkedinLogin,
  showWelcomeBack,
  // filtering,
  linkedinLoading,
  filter: {
    skill,
    company,
    location,
    role
  },
  user,
}) => <Fragment>
  <Header>
    <Logo/>
    <div className="row no-gutters">
      <div className="container">
        <div className="row no-gutters">
          <div className="col text-center">
            <Title>Opportunities</Title>
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            <SubTitle>at Aleph&apos;s Portfolio Companies</SubTitle>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-md-3 mt-2">
            <Multiselect label="Skill" placeholder="Select a Skill" value={skill} options={skills} onChange={(value) => updateFilter('skill', value)}/>
          </div>
          <div className="col-md-3 mt-2">
            <Multiselect label="Location" placeholder="Location" value={location} options={locations} onChange={(value) => updateFilter('location', value)} />
          </div>
          <div className="col-md-3 mt-2">
            <Multiselect label="Company" placeholder="Company" value={company} options={companies} onChange={(value) => updateFilter('company', value)}/>
          </div>
          <div className="col-md-3 mt-2">
            <Multiselect label="Role" placeholder="Role" value={role} options={roles} onChange={(value) => updateFilter('role', value)}/>
          </div>

        </div>
        {/* <div className="row">
          <SearchButton className="invisible"/>
        </div> */}
      </div>

    </div>
  </Header>
  <div className="container">
    <div className="row">
      <div className="col-12">
        <Counter positions={positions} filter={{skill, company, location, role}} />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="card mb-3 shadow-sm">
          <div>
          </div>
          {(user === null || showWelcomeBack) && (
           <div className="card-body">
              <p className="card-text linkedin-login">
                  {user == null && (
                      <center>
                        <NotSignedInText/>
                      </center>
                    )}
                  {showWelcomeBack && (
                      <center>
                        <WelcomeBackText user={user} onOptInToggle={() => belatedOptin(store)} />
                      </center>
                  )}
              </p>
              {user === null && <Login loading={linkedinLoading} loginSuccessHandler={linkedinLogin}/>}
          </div>
          )}
        </div>
      </div>
    </div>
    {(user !== null || process.env.NODE_ENV === 'development') && (
    <div className="row">
      <div className="col-md mt-3">
        <Cards positions={positions} user={user} />
      </div>
    </div>
    )}

  </div>
  <Footer />
</Fragment>


const mapStateToProps = (state) => {
  const { positions: { filter } } = state
  return { ...state.positions, positions: filteredSlection(state), filter }
}

const mapDispatchToProps = dispatch => bindActionCreators({ updateFilter, linkedinLogin }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main)



// WEBPACK FOOTER //
// ./src/pages/main.js